/**
 *  custom-state.js
 *      Generates Tailwind classes that will only apply styles if a state class is present on the same element.
 *      See the docs for instructions on how to add new custom states.
 *
 *      Example:
 *          <!-- this has no effect on the text color -->
 *          <div class="selected:f-text-red-500">Hello World</div>
 *
 *          <!-- now the text color changes to red -->
 *          <div class="is-selected selected:f-text-red-500">Hello World</div>
 */

const { upperCase } = require('change-case');
const { STATE_CLASSES } = require('../data/constants/classes');

module.exports.variant = function customStatePlugin({ addVariant, e }) {
    const customStates = ['selected', 'expanded', 'matching'];

    customStates.forEach((state) => {
        addVariant(state, ({ separator, container }) => {
            const stateClass = STATE_CLASSES[upperCase(state)];
            const selectedStr = `${ state }${ e(separator) }`;

            container.walkRules((rule) => {
                const selectorNew = `.${ stateClass }.${ selectedStr }${ rule.selector.slice(1) }`;

                // sample output = .is-selected.state\:f-text-red-500
                rule.selector = selectorNew;
            });
        });
    });
};
